import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function exportInsightsTableReducer(state = initialState.exportInsights, action) {
    switch (action.type) {
    case types.LOAD_EXPORT_INSIGHTS_TABLE_ALL_SUCCESS:
        return action.exportInsights;
    default:
        return state;
    }
}